import React from 'react';
import { useTranslation } from 'react-i18next';
import './SignOutButton.css';

function SignOutButton({ onSignOut }) {
  const { t } = useTranslation();

  return (
    <button className="signout-button" onClick={onSignOut} title={t('signout.title')}>
      {t('signout.label')}
    </button>
  );
}

export default SignOutButton;
